import { classNames } from "@components/library/utils/classNames";
import { useBreakpoints } from "hooks/useBreakpoints";
import React from "react";

export const BackgroundDiagonalRings = ({
  children,
  className,
}: React.PropsWithChildren<{ className?: string }>) => {
  const { isMediumWidth, isLargeWidth } = useBreakpoints();

  return (
    <div className={classNames("relative overflow-hidden", className)}>
      <img
        alt=""
        src="/assets/lissajous/lissajous-1-rotated-displaced.svg"
        className=" absolute -top-[180px] -left-[170px] w-1/4 select-none"
      />
      {children}
      <img
        alt=""
        src="/assets/lissajous/lissajous-1-rotated-displaced.svg"
        className=" absolute -bottom-[170px] -right-[180px] w-1/4 select-none"
      />
    </div>
  );
};
